import type { ISocialOffer } from "@bbj-types/offer";
import { Divider, Stack } from "@mui/material";
import type { ISocialOfferWithFavoriteChallenges } from "@root/api/services/offers/socialOffer/types";
import { useGlobalContext } from "@root/context";
import type { Dispatch, SetStateAction } from "react";
import { SocialOfferDescription } from "./description";
import { SocialOfferHeader } from "./header";
import { SocialOffersDetailsInfoStack, classes } from "./styles";
import { SocialOfferType } from "./type";
import { SocialOfferUsefulInformations } from "./usefulInformations";

interface ISocialOffersDetailsInfoProps {
  offer: ISocialOffer;
  setDrawerOffer: (offer: ISocialOffer | null) => void;
  setIsModalOpen?: Dispatch<SetStateAction<boolean>>;
  onUpdate?: (offer: ISocialOfferWithFavoriteChallenges) => void;
}

export const SocialOffersDetailsInfo = ({
  offer,
  setDrawerOffer,
  setIsModalOpen,
  onUpdate,
}: ISocialOffersDetailsInfoProps) => {
  const { challenges } = useGlobalContext();

  return (
    <SocialOffersDetailsInfoStack className={classes.root}>
      <SocialOfferHeader offer={offer} setIsModalOpen={setIsModalOpen} onUpdate={onUpdate} />
      <Stack className={classes.content}>
        <SocialOfferType offer={offer} challenges={challenges} />
        <SocialOfferUsefulInformations offer={offer} />
      </Stack>
      <Divider sx={{ width: "100%" }} />
      <SocialOfferDescription offer={offer} setDrawerOffer={setDrawerOffer} />
    </SocialOffersDetailsInfoStack>
  );
};
